/**
 * HeroSection.jsx
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import CTAButton from '../common/CTAButton';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section" aria-labelledby="hero-heading">

      {/* -- Floating animated bubbles -- */}
      <div className="hero-section__bubble hero-section__bubble--1" aria-hidden="true" />
      <div className="hero-section__bubble hero-section__bubble--2" aria-hidden="true" />
      <div className="hero-section__bubble hero-section__bubble--3" aria-hidden="true" />

      {/* -- Tagline badge -- */}
      <div className="hero-section__badge" aria-hidden="true">
        QuitPact
      </div>

      {/* -- Primary heading -- */}
      <h1 id="hero-heading" className="hero-section__heading">
        Check Your Smoking{' '}
        <span className="hero-section__heading--highlight">Relapse </span>
        <span className="hero-section__heading--risk">Risk.</span>
      </h1>

      {/* -- Value proposition -- */}
      <p className="hero-section__value-prop">
        A 2 minute check in that shows when quitting may feel harder and what
        to do next.
      </p>

      {/* -- Single primary CTA -- */}
      <CTAButton
        label="Click to Check-in"
        to="/check-in"
        ariaLabel="Start your relapse risk check-in"
        className="hero-section__cta"
      />

    </section>
  );
};

export default HeroSection;
